import { Box, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import Share from "./Share";
import { GatsbyImage } from "gatsby-plugin-image";
import { head, map } from "lodash";
import QueryPreservingLink from "../../../components/QueryPreservingLink";

const Post = ({
  title,
  slug,
  author,
  excerpt,
  categories,
  tags,
  date,
  featuredImage,
  id,
}) => {
  const category = head(categories.nodes);

  return (
    <Paper
      sx={{
        borderRadius: "10px",
        boxShadow: "-10px 11.1px 50px 0 rgba(188, 198, 210, 0.33)",
      }}
      component={Stack}
    >
      <Box
        sx={{ alignSelf: "end", mr: "20px", mt: "20px" }}
        component={Share}
        url={`${process.env.GATSBY_SITE_URL}/blog/${slug}`}
      />

      <Stack
        sx={{
          paddingTop: { xs: "24px", md: "40px" },
          paddingRight: { xs: "24px", md: "84px" },
          paddingBottom: "57.4px",
          paddingLeft: { xs: "24px", md: "47px" },
        }}
      >
        <Stack direction={{ xs: "column", md: "row" }}>
          <Stack
            sx={{
              flexShrink: 0,
              flexBasis: { xs: "auto", md: "33.33%" },
              maxWidth: { xs: "auto", md: "33.33%" },
              marginBottom: "12px",
            }}
          >
            <GatsbyImage
              image={
                featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData
              }
              alt={featuredImage?.node?.altText}
            />
          </Stack>

          <Stack sx={{ flexGrow: 1, paddingLeft: { xs: 0, md: "25px" } }}>
            <Stack
              sx={{
                marginBottom: "8.3px",
                justifyContent: "start",
                flexWrap: "wrap",
              }}
              direction="row"
            >
              {map(tags.nodes, ({ id, name, slug }) => (
                <Stack
                  component={QueryPreservingLink}
                  to={`/blog/tag/${slug}`}
                  key={id}
                  sx={{
                    minWidth: "50px",
                    height: "23px",
                    borderRadius: "5px",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#626972",
                    textDecoration: "none",
                    marginRight: "5px",
                    padding: "2px 28.8px 2.8px 20.1px",
                    marginBottom: "6px",
                    backgroundColor: "rgba(162, 170, 181, 0.35)",
                    fontWeight: "normal",
                    lineHeight: 0.6,
                  }}
                >
                  {name}
                </Stack>
              ))}
            </Stack>

            <Stack sx={{ marginBottom: "6px" }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#a2aab5",
                  lineHeight: 1.25,
                }}
              >
                {date}
              </Typography>
            </Stack>

            <Box
              sx={{
                fontWeight: 900,
                fontSize: "22px",
                lineHeight: 1.03,
                color: "#3f119b",
                marginTop: "5px",
              }}
              dangerouslySetInnerHTML={{ __html: title }}
            />

            <Box
              sx={{
                marginTop: "10px",
                fontSize: "16px",
                fontWeight: 500,
                lineHeight: 1.25,
                color: "#626972",
              }}
            >
              <span>by</span>

              <Box
                sx={{
                  textDecoration: "none",
                  color: "#6a27e8",
                  mx: "4px",
                }}
                component={QueryPreservingLink}
                to={`/blog/author/${author?.node.slug}`}
              >
                {author?.node.name}
              </Box>

              <span>in</span>

              <Box
                sx={{
                  textDecoration: "none",
                  color: "#6a27e8",
                  mx: "4px",
                }}
                component={QueryPreservingLink}
                to={`/blog/category/${category.slug}`}
              >
                {category.name}
              </Box>
            </Box>

            <Box
              sx={{
                marginTop: "10px",
                fontSize: "18px",
                lineHeight: 1.41,
                color: "#626972",
              }}
              dangerouslySetInnerHTML={{ __html: excerpt }}
            />

            <Box
              component={QueryPreservingLink}
              to={`/blog/${slug}`}
              sx={{
                marginTop: "18px",
                maxWidth: "178px",
                width: "100%",
                height: "50px",
                borderRadius: "10px",
                backgroundColor: "transparent",
                border: "solid 2px #6a27e8",
                color: "#6a27e8",
                textDecoration: "none",
                fontSize: "16px",
                fontWeight: "bold",
                lineHeight: 1.07,
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "24px",
                "&:hover": {
                  backgroundColor: "#6a27e8",
                  color: "#ffffff",
                },
              }}
            >
              READ MORE
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default Post;
